function handleUpcomingEventsViewAll(): void {
  document.querySelectorAll('.upcoming-events-component .btn.show-all').forEach(btn => {
    btn.addEventListener('click', function (event) {
      btn.closest('.upcoming-events-component').classList.add('all-shown');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  handleUpcomingEventsViewAll();
});
